import {AcceptedPayments} from '../../../shared-gen/Payment/Rules/AcceptedPayments';

export class AcceptedPaymentsFun {

    static none(): AcceptedPayments {
        return {
            HardCash: false,
            Coins: [],
            Bills: [],
            Tokens: [],
            Cashless: false,
            QR: false,
            SaniFair: false,
            ClosedLoop: false,
            PaymentApi: false
        }
    }

}
